import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';
import type { PIIString } from '@trello/privacy';
import { usePathname } from '@trello/router';
import { escapeReturnUrl } from '@trello/urls';

import { CopyBoardViewPopover } from './CopyBoardViewPopover';

import styles from './UseTemplateButton.less';

const SignUpLink: FunctionComponent = () => {
  const pathname = usePathname();
  const returnUrl = escapeReturnUrl(pathname);

  return (
    <Button
      className={styles.button}
      appearance="primary"
      href={`/signup?returnUrl=${returnUrl}`}
    >
      <FormattedMessage
        id="templates.templates.use-template"
        defaultMessage="Use template"
        description="A button allowing the user to use the chosen template"
      />
    </Button>
  );
};

interface UseTemplateButtonProps {
  boardId: string;
  username?: PIIString;
}

export const UseTemplateButton: FunctionComponent<UseTemplateButtonProps> = ({
  boardId,
  username,
}) => {
  return username ? <CopyBoardViewPopover idBoard={boardId} /> : <SignUpLink />;
};
